export default "__VITE_ASSET__Ce1iBVZM__"